export const PHOTO_PRINT_TARGET_ASPECT = 1.5; // 2:3 portrait (height / width)
export const PHOTO_PRINT_EXPORT_WIDTH = 1200;
export const PHOTO_PRINT_EXPORT_HEIGHT = 1800;
export const PHOTO_PRINT_ASPECT_MISMATCH_THRESHOLD = 0.08;

export type PhotoPrintCropMode = '2:3' | 'fit';

export function normalizePhotoPrintCropAspectRatio(value: unknown): PhotoPrintCropMode {
  if (value === 'fit') return 'fit';
  return '2:3';
}

export function isPhotoPrintAspectMismatch(
  width: number,
  height: number,
  cropMode: PhotoPrintCropMode = '2:3',
  rotationDegrees = 0,
) {
  if (cropMode !== '2:3') return false;

  const swapped = Math.abs(rotationDegrees) % 180 !== 0;
  const orientedWidth = swapped ? height : width;
  const orientedHeight = swapped ? width : height;
  const imageAspect = orientedHeight / orientedWidth;
  const relativeDeviation =
    Math.abs(imageAspect - PHOTO_PRINT_TARGET_ASPECT) / PHOTO_PRINT_TARGET_ASPECT;

  return relativeDeviation > PHOTO_PRINT_ASPECT_MISMATCH_THRESHOLD;
}

export function loadImageNaturalSize(src: string) {
  return new Promise<{ width: number; height: number }>((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      if (image.naturalWidth === 0 || image.naturalHeight === 0) {
        reject(new Error('Image decoded with zero dimensions'));
        return;
      }
      resolve({ width: image.naturalWidth, height: image.naturalHeight });
    };
    image.onerror = () => reject(new Error('Image failed to load'));
    image.src = src;
  });
}
